<div class="graph-content-wrapper">
    <div class="content" [hidden]="!showChart" #genericGraphContainer [id]="'chart-' + chartId">
        <canvas #genericGraphCanvas></canvas>
    </div>
    <div [class.chart-placeholder]="!showChart" [class.no-print]="!showChart" [hidden]="showChart">
        <mat-icon class="material-symbols-outlined" color="warn">
            error
        </mat-icon>
        <span>Unable to display chart</span>
    </div>
</div>